<template>
  <div
    v-if="publishedContract"
    class="boss-pickup-wrap"
  >
    <div
      class="boss-pickup-form"
    >
      <!-- ▼本日のおすすめ見出し -->
      <div class="boss-pickup-headline">
        <h2 class="boss-pickup-title">
          <span class="boss-icon boss-icon-pickup" />
          <span>本日のおすすめ</span>
        </h2>
        <!-- ▼本日のおすすめ求人プルダウン -->
        <div class="boss-pulldown-container boss-published margin-bottom-0">
          <label
            class="boss-pulldown-menu"
            for="boss-published-item"
          >
            <select
              id="boss-published-item"
              v-model="selectedJobId"
              class="boss-pulldown-menu-item"
              data-test="job-pulldown"
              @change="onChangeJob"
            >
              <option
                v-for="(job,key) in publishedContract.jobs.filter(job => job.isPublished)"
                :key="key"
                :data-test="'job-' + key"
                :value="job.id"
              >求人ID: {{ job.id }} {{ job.managementName }}</option>
            </select>
          </label>
        </div>
        <!-- ▲本日のおすすめ求人プルダウン -->
      </div>
      <!-- ▲本日のおすすめ見出し -->
      <div class="boss-form-container">
        <div class="boss-layout boss-layout-vertical boss-layout-fill">
          <div>
            <div
              class="boss-batch-container clearfix padding-top-0"
            >
              <scout-members-bulk-register
                :job-id="selectedJobId"
                :contract-id="publishedContract.id"
                :member-objects="checkedMemberObjects"
                @fetch="fetchRecommended(publishedContract.id, selectedJobId)"
                @clearCheckedMembers="clearCheckedMembers"
              />
            </div>
          </div>
          <div>
            <div
              class="boss-resumecard-list"
            >
              <template
                v-for="(memberObject, i) in infinityMemberObjects"
              >
                <scout-resume-card
                  v-if="!memberObject.member.isScoutExcluded"
                  :key="i"
                  :member-object="memberObject"
                  :checked="checkedMemberIds"
                  :contract-id="publishedContract.id"
                  :job-id="selectedJobId"
                  :shows-scout-button="isSendScout"
                  :shows-like-button="isSendScout"
                  @spliceCheckedMember="spliceCheckedMember"
                  @checked="checked"
                  @change="changed"
                />
              </template>
            </div>
          </div>
          <infinite-loading
            ref="infiniteLoading"
            @infinite="infiniteHandler"
          >
            <div
              slot="no-more"
              data-test="infinite-loading-no-more"
            >
              全{{ displayCount }}件
            </div>
            <div
              slot="no-results"
              data-test="no-results-label"
            >
              {{ noResultsLabel }}
            </div>
          </infinite-loading>
          <div
            v-if="showRecommendedLess"
            class="text-center"
            data-test="recommended-less"
          >
            <div>「本日のおすすめ」は、各求人のマッチング条件とtype会員の行動をもとにした、貴社へのスカウトおすすめ会員です。</div>
            <div>表示されない場合は、マッチング条件の変更などを制作担当者へご相談ください。</div>
          </div>
          <selected-counter
            :checked-count="checkedMemberIds.length"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ScoutResumeCard from '@/components/organisms/ScoutResumeCard'
import ScoutMembersBulkRegister from '@/components/molecules/ScoutMembersBulkRegister'
import SelectedCounter from '@/components/molecules/SelectedCounter'
import InfiniteLoading from 'vue-infinite-loading'
import _ from 'lodash'
import InfinityScrollIterator from '@/lib/infinityScrollIterator'
import { mapGetters } from 'vuex'
import Indicator from '@/lib/indicator'

export default {
  components: {
    ScoutResumeCard,
    ScoutMembersBulkRegister,
    SelectedCounter,
    InfiniteLoading
  },
  data () {
    return {
      memberObjects: [],
      checkedMemberIds: [],
      infinityMemberObjects: [],
      selectedJobId: null,
      infinityScrollIterator: new InfinityScrollIterator(this.memberObjects)
    }
  },
  computed: {
    noResultsLabel () {
      if (!Indicator.getLoadingStatus()) {
        return 'おすすめ会員がいません。'
      }
      return ''
    },
    checkedMemberObjects () {
      return this.checkedMemberIds.map(id => _(this.memberObjects).find({ id: id }))
    },
    publishedContract () {
      return _.head(this.publishedContracts)
    },
    ...mapGetters('contracts', [
      'publishedContracts'
    ]),
    ...mapGetters([
      'isSendScout'
    ]),
    showRecommendedLess () {
      return this.memberObjects.length <= 20 && !Indicator.getLoadingStatus()
    },
    displayCount () {
      return this.infinityMemberObjects.filter(memberObject => !memberObject.member.isScoutExcluded).length
    }
  },
  watch: {
    memberObjects (val) {
      this.resetInfinityScroll(val)
    },
    publishedContracts: {
      handler (val, oldVal) {
        // 契約情報に変更がない場合は実行しない(初回描画時の考慮) & 有効な契約がない場合にエラーになるため
        if (!_.isEqual(val, oldVal) && val.length) {
          const contract = _.head(val)
          const job = _.head(contract.jobs.filter(job => job.isPublished))
          if (job) {
            this.$set(this, 'selectedJobId', Number(job.id))
            this.fetchRecommended(contract.id, job.id)
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    checked (id) {
      if (!_.includes(this.checkedMemberIds, id)) {
        this.checkedMemberIds.push(id)
      }
    },
    changed (val) {
      if (_.includes(this.checkedMemberIds, val)) {
        this.checkedMemberIds.splice(this.checkedMemberIds.findIndex(n => n === val), 1)
      } else {
        this.checkedMemberIds.push(val)
      }
    },
    clearCheckedMembers () {
      this.$set(this, 'checkedMemberIds', [])
    },
    infiniteHandler ($state) {
      const next = this.infinityScrollIterator.next()
      if (next.done) {
        $state.complete()
      } else {
        this.infinityMemberObjects.push(...next.value)
        $state.loaded()
      }
    },
    resetInfinityScroll (memberObjects) {
      if (this.$refs.infiniteLoading.stateChanger) {
        this.$refs.infiniteLoading.stateChanger.reset()
      }
      this.infinityMemberObjects = []
      this.infinityScrollIterator = new InfinityScrollIterator(memberObjects)
    },
    fetchRecommended (contractId, jobId) {
      Indicator.emitShow()
      this.$http.secured.get(`/scout/view/scouts/contracts/${contractId}/jobs/${jobId}/recommended_users`)
        .then(response => {
          const members = response.data.map((member) => {
            return {
              id: member.recommendedId,
              member: { ...member, isScoutExcluded: false }
            }
          })
          this.$set(this, 'memberObjects', members)
        }).finally(() => {
          Indicator.emitHide()
        })
    },
    spliceCheckedMember (memberObjectId) {
      this.checkedMemberIds.splice(this.checkedMemberIds.findIndex(id => id === memberObjectId), 1)
    },
    onChangeJob () {
      this.fetchRecommended(this.publishedContract.id, this.selectedJobId)
      this.$set(this, 'checkedMemberIds', [])
    }
  }
}
</script>
